

import * as constants from "../constants";

export function userSearchResults(state = [], action) {
  switch (action.type) {
    case constants.UPDATE_USER_SEARCH_RESULTS:
      return action.userSearchResults;
    default:
      return state;
  }
}

export function userSearchResultsHeight(state = "0px", action) {
  switch (action.type) {
    case constants.UPDATE_USER_SEARCH_RESULTS_HEIGHT:
      return action.height;
    default:
      return state;
  }
}

export function userSearchStatus(state = "", action) {
  switch (action.type) {
    case constants.CHANGE_USER_SEARCH_STATUS:
      return action.status;
    default:
      return state;
  }
}

export function userSearchInView(state = false, action) {
  switch (action.type) {
    case constants.CHANGE_USER_SEARCH_IN_VIEW:
      return action.status;
    default:
      return state;
  }
}

export function selectedUsers(state = [], action) {
  switch (action.type) {
    case constants.ADD_AUTO_COMPLETE_SELECTED_USER:
      return [...state, action.user];
    case constants.REMOVE_SELECTED_USER:
      return [
        ...state.slice(0, action.index),
        ...state.slice(action.index + 1)
      ];
    case constants.REMOVE_ALL_SELECTED_USERS:
      return [];
    default:
      return state;
  }
}

export function hoverSelectedUserIndex(state = 0, action) {
  switch (action.type) {
    case constants.CHANGE_SELECTED_USER:
      return action.index;
    default:
      return state;
  }
}

export function autoCompleteTextAreaValue(state = "", action) {
  switch (action.type) {
    case constants.UPDATE_AUTO_COMPLETE_TEXT_AREA_VALUE:
      return action.value;
    default:
      return state;
  }
}
